import React from "react";
import { useTranslation } from "react-i18next";
import { Phone, Mail } from "lucide-react";
import { useSettingsStore } from "../../store/settingsStore";

export default function TopBar() {
    const { t } = useTranslation();
    const { settings } = useSettingsStore();

    return (
        <div
            data-testid="public-top-bar"
            className="hidden lg:block bg-dark-navy text-white text-xs"
        >
            <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
                <div className="flex items-center gap-2 text-white/85">
                    <span className="inline-block h-1.5 w-1.5 rounded-full bg-teal" />
                    <span className="tracking-wide uppercase font-medium">
                        {t("tagline")}
                    </span>
                </div>
                <div className="flex items-center gap-6 text-white/80">
                    <a
                        href={`tel:${settings.phone?.replace(/\s/g, "")}`}
                        className="flex items-center gap-2 hover:text-teal"
                        data-testid="topbar-phone"
                    >
                        <Phone className="w-3.5 h-3.5" />
                        <span>{settings.phone}</span>
                    </a>
                    <a
                        href={`mailto:${settings.email}`}
                        className="flex items-center gap-2 hover:text-teal"
                        data-testid="topbar-email"
                    >
                        <Mail className="w-3.5 h-3.5" />
                        <span>{settings.email}</span>
                    </a>
                    <a
                        href="#newsletter"
                        className="text-gold hover:text-white font-semibold tracking-wide"
                        data-testid="topbar-newsletter"
                    >
                        {t("actions.subscribe")} →
                    </a>
                </div>
            </div>
        </div>
    );
}
